module.exports = __webpack_public_path__ + "img/star.ecce737b.svg";